export const getEnvironment = (): string => {
  const host = window.location.hostname;
  if (host === "local.restless.co.uk") return "local";
  if (host === "staging.restless.co.uk") return "staging";
  if (host === "dev.restless.co.uk") return "dev";
  if (host === "restless.co.uk") return "production";
  return "local";
};

export const userAgentSuggestsMobile = () => {
  // try new api
  if (navigator.userAgentData) {
    return navigator.userAgentData.mobile;
  }
  // legacy implementation
  else {
    return /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
  }
};

export const isMobileViewport = () => {
  return window.innerWidth < 992;
};
